import 'vant/lib/picker/index.less'

// 依赖
import '../preview-text/style'
